import { useSyncExternalStore } from 'react'
import { gameStore } from './store'
import type { GameState } from './types'

export function useGame(): GameState {
  return useSyncExternalStore(gameStore.subscribe, gameStore.getSnapshot, gameStore.getSnapshot)
}

export { gameStore }
